// This component renders a large, brand-styled button/tile used on the NSC hero.
// Business logic: visual CTA with animated underline on hover. It supports optional linking.
"use client";

import Link from "next/link";
import { cn } from "@/lib/utils";
import Arrow from "@/components/icons/Arrow";

type AnimatedButtonProps = {
  text: string;
  href?: string;
  className?: string;
  target?: "_self" | "_blank";
};

const AnimatedButton = ({ text, href, className, target = "_self" }: AnimatedButtonProps) => {
  const Content = (
    <div
      className={cn(
        "group relative flex h-full w-full flex-col justify-end rounded-default bg-nsc-yellow text-nsc-dark-blue p-3.5",
        "opacity-0 will-change-transform animate-slide-in-right md:animate-slide-in-bottom motion-reduce:opacity-100 motion-reduce:animate-none",
        className
      )}
    >
      <Arrow color="#171C60" className="absolute left-3 top-3 h-[19px] w-[19px]" />
      <span className={cn("relative block w-fit uppercase header-4")}>
        <span
          className={cn(
            "inline box-decoration-clone [-webkit-box-decoration-break:clone]",
            "bg-[linear-gradient(currentColor,currentColor)] bg-no-repeat [background-position:0_calc(100%_-_2px)] bg-[length:0%_1px]",
            "transition-[background-size] duration-300 ease-out",
            "group-hover:bg-[length:100%_1px]",
            // Safari-specific fixes to prevent overlap while allowing line breaks
            "[-webkit-hyphens:manual] [hyphens:manual]",
            "[word-break:break-word]"
          )}
        >
          {text}
        </span>
      </span>
    </div>
  );

  if (href) {
    return (
      <Link href={href} target={target} className="focus:outline-none">
        {Content}
      </Link>
    );
  }

  return Content;
};

export default AnimatedButton;


